'use strict';

var gcpRegionTypes = {
    SINGLE: 'SINGLE',
    DUAL: 'DUAL',
    MULTI: 'MULTI'
};

module.exports = gcpRegionTypes;